var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.bankAbbrev)?_c('img',{staticClass:"bank",style:(("background-color: " + _vm.bankColor)),attrs:{"alt":_vm.bankAbbrev,"src":require(("@assets/images/banks/" + _vm.bankAbbrev + ".svg")),"width":"25"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }